import { apiCall, apiCallAdmin, apiCallGeneric } from "../../services/api-service.js";

const isAbsoluteUrl = (endpoint) => /^https?:\/\//i.test(endpoint);

const normalizeEndpoint = (endpoint) => endpoint.replace(/^\/+/, "");

const apiBaseUrl = process.env.REACT_APP_API_URL || "";
const adminBaseUrl = process.env.REACT_APP_ADMIN_API_URL || "";

const getRelativeEndpointForKnownBase = (endpoint) => {
    if (!isAbsoluteUrl(endpoint)) {
        return { kind: "relative", endpoint: normalizeEndpoint(endpoint) };
    }

    if (apiBaseUrl && endpoint.startsWith(apiBaseUrl)) {
        return {
            kind: "api",
            endpoint: normalizeEndpoint(endpoint.slice(apiBaseUrl.length)),
        };
    }

    if (adminBaseUrl && endpoint.startsWith(adminBaseUrl)) {
        return {
            kind: "admin",
            endpoint: normalizeEndpoint(endpoint.slice(adminBaseUrl.length)),
        };
    }

    return { kind: "absolute", endpoint };
};

const requestApi = async (method, endpoint, data = null, options = {}) => {
    const normalized = getRelativeEndpointForKnownBase(endpoint);

    const response = normalized.kind === "absolute"
        ? await apiCallGeneric(method, normalized.endpoint, data, options)
        : normalized.kind === "admin"
            ? await apiCallAdmin(method, normalized.endpoint, data, options)
            : await apiCall(method, normalized.endpoint, data, options);

    if (response?.status >= 400) {
        throw { response };
    }

    return response?.data;
};

export const getApi = async (endpoint, params = {}, headers = {}) => {
    return requestApi("get", endpoint, null, {
        params,
    });
};

export const deleteApi = async (endpoint, params = {}, headers = {}) => {
    return requestApi("delete", endpoint, null, {
        params,
    });
};

export const postApi = async (endpoint, data = {}, headers = {}) => {
    return requestApi("post", endpoint, data, {
    });
};

export const putApi = async (endpoint, data = {}, headers = {}) => {
    return requestApi("put", endpoint, data, {
    });
};
